module.exports = __webpack_public_path__ + "img/evaluate1.a6e1fdf9.png";